export interface SeoOptions {
  title: string;
  description: string;
  keywords?: string;
  path: string;
  type?: "website" | "article";
  jsonLd?: Record<string, unknown>[];
}

function setMeta(name: string, content: string) {
  let el = document.querySelector(`meta[name="${name}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute("name", name);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function setProperty(property: string, content: string) {
  let el = document.querySelector(`meta[property="${property}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute("property", property);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function upsertJsonLd(scriptId: string, data: Record<string, unknown>[]) {
  const old = document.getElementById(scriptId);
  if (old) old.remove();
  const script = document.createElement("script");
  script.id = scriptId;
  script.type = "application/ld+json";
  script.textContent = JSON.stringify(data);
  document.head.appendChild(script);
}

const baseUrl = "https://yusr.com.cn";

export function applySeo(opts: SeoOptions) {
  const canonical = `${baseUrl}${opts.path === "/" ? "" : opts.path}`;
  document.title = opts.title;
  setMeta("description", opts.description);
  if (opts.keywords) setMeta("keywords", opts.keywords);
  setProperty("og:type", opts.type ?? "website");
  setProperty("og:url", canonical);
  setProperty("og:title", opts.title);
  setProperty("og:description", opts.description);
  setProperty("twitter:title", opts.title);
  setProperty("twitter:description", opts.description);
  let canonicalEl = document.querySelector('link[rel="canonical"]');
  if (!canonicalEl) {
    canonicalEl = document.createElement("link");
    canonicalEl.setAttribute("rel", "canonical");
    document.head.appendChild(canonicalEl);
  }
  canonicalEl.setAttribute("href", canonical);
  if (opts.jsonLd && opts.jsonLd.length) {
    upsertJsonLd("page-jsonld", opts.jsonLd);
  }
}